import { useMediaQuery } from "@mui/material";

export const IsMobileView = () => {
    const matches = useMediaQuery('(max-width:600px)');
    return matches;
  }